// Shared design-system components for every module in the dashboard.
//
// Originally built during the MAFIA Aux + Digital Inspection visual
// upgrade pass at `src/pages/Mafia/_shared/`. Moved here as the kit
// expanded out to EPO, DMS, HR, Contract Review, Attendance, Org
// Chart, Display Boards, and the rest.
//
// Stays inside the existing Velzon/Skote theme — no global theme
// files changed, no new SCSS, just composed Reactstrap + Bootstrap
// utility classes + the dashboard's existing Remix icons and CountUp
// animations.
//
// Pass 1 (UI standardization, 2026): added the second wave of shared
// components — ModuleShortcutCard, ModuleLandingGrid, PageActionBar,
// FilterToolbar, FormSectionCard, ResponsiveTabs, CompactStatsRow,
// QuickActionButton, PageHelpText, StandardTableToolbar, and a flat
// ComingSoonCard replacement for the legacy video-based ComingSoon.
//
// IMPORTANT: nothing in this folder owns business state, fetches
// from the API, or alters submit payloads. Every component is pure
// presentation. Keep it that way.

import DashboardPageHeader from "./DashboardPageHeader";

export { default as DashboardPageHeader } from "./DashboardPageHeader";

// Backwards-compat alias for existing Mafia/DI code that imported
// `MafiaPageHeader` from this kit's previous location at
// `src/pages/Mafia/_shared`. Same component, two import names.
export const MafiaPageHeader = DashboardPageHeader;

// Original kit ─────────────────────────────────────────────────────
export { default as StatTile } from "./StatTile";
export { default as StatusBadge } from "./StatusBadge";
export { default as EmptyState } from "./EmptyState";
export { default as TableSkeleton } from "./TableSkeleton";
export { default as DataTableShell } from "./DataTableShell";
export { default as SectionCard } from "./SectionCard";

// Pass 1 additions ─────────────────────────────────────────────────
export { default as ModuleShortcutCard } from "./ModuleShortcutCard";
export { default as ModuleLandingGrid } from "./ModuleLandingGrid";
export { default as PageActionBar } from "./PageActionBar";
export { default as FilterToolbar } from "./FilterToolbar";
export { default as FormSectionCard } from "./FormSectionCard";
export { default as ResponsiveTabs } from "./ResponsiveTabs";
// R41 — per-column filter row + client-side filter helper.
export { default as ColumnFilterRow, applyColumnFilters } from "./ColumnFilterRow";
// R44 — debounce hook used by server-side column filtering.
export { default as useDebouncedValue } from "./useDebouncedValue";
export { default as CompactStatsRow } from "./CompactStatsRow";
export { default as QuickActionButton } from "./QuickActionButton";
export { default as PageHelpText } from "./PageHelpText";
export { default as StandardTableToolbar } from "./StandardTableToolbar";
export { default as ComingSoonCard } from "./ComingSoonCard";
// Owner (2026-10-05): the department landing pages list their modules and KPI reports.
export { DeptToolsGrid, DeptReportsGrid, DEPT_TOOLS } from "./DeptLandingSections";

// Pass 5 additions ─────────────────────────────────────────────────
// SideNavTabs is the vertical counterpart of ResponsiveTabs — used by
// the HR sub-tab strips (TimelineTabs, HRReportsTimelineTabs,
// MissingPunchesTabs, WebFormsTimelineTabs).
export { default as SideNavTabs } from "./SideNavTabs";
